<template>
	<div>
		
		<ModalHeaderTitle :title="'Registrate'" />

		<form action="" @submit.prevent="register">
			<div class="field">
				<div class="control">
					<input
					class="input"
					:class="errors.nombre ? 'is-danger' : ''"
					v-model="nombre"
					type="text"
					placeholder="Ingresa tu nombre.."
					/>
				</div>
				<p v-for="(error, key) in errors.nombre" :key="key" class="help is-danger">
					{{ error }}
				</p>
			</div>
			<div class="field">
				<div class="control has-icons-left ">
					<input
					class="input"
					:class="errors.email ? 'is-danger' : ''"
					v-model="email"
					type="email"
					placeholder="Ingresa tu email.."
					required />
					<span class="icon is-small is-left">
						<font-awesome-icon icon="envelope" />
					</span>
				</div>
				<p
				v-for="(error, key) in errors.email"
				:key="key"
				class="help is-danger"
				>
				{{ error }}
			</p>
		</div>
		<div class="field">
			<div class="control has-icons-left">
				<input
				class="input"
				:class="errors.password ? 'is-danger' : ''"
				v-model="password"
				type="password"
				placeholder="Ingresa tu contraseña.."
				/>
				<span class="icon is-small is-left">
					<font-awesome-icon icon="lock" />
				</span>
			</div>
			<p
			v-for="(error, key) in errors.password"
			:key="key"
			class="help is-danger"
			>
			{{ error }}
		</p>
	</div>
	
	<div class="field">
		<div class="control has-icons-left">
				<div class="select is-fullwidth" :class="errors.equipo ? 'is-danger' : ''">
					<select name="" v-model="equipo" id="">
						<option value="" disabled selected>Elije tu equipo favorito...</option>
						<optgroup v-for="liga in ligasNoVacias" :key="liga.id" :label="liga.nombre">
							<option :value="equipo.id" v-for="equipo in liga.equipos" :key="equipo.id">{{ equipo.nombre }}</option>
						</optgroup>
					</select>
				</div>
				<div class="icon is-small is-left">
					<font-awesome-icon icon="futbol" />
				</div>
				<p v-for="(error, key) in errors.equipo" :key="key" class="help is-danger">
					{{ error }}
				</p>
			</div>	
	</div>
	
	<div class="level">
		<div class="level-left">
			<div class="level-item">
				<button class="button is-primary is-fullwidth">Registrar</button>
			</div>
		</div>
		<div class="level-right">
			<div class="level-item">
				<FacebookLoginButton v-on:success="fbSuccess" v-on:failed="fbFailed" />
			</div>
			<div class="level-item">
				<GoogleLoginButton v-on:success="googleSuccess" v-on:error="googleFailed" />
			</div>
		</div>
	</div>
</form>
</div>
</template>

<script>
	import ModalHeaderTitle from '@/components/ModalHeaderTitle'
	import { mapState } from 'vuex'
	import FacebookLoginButton from '@/components/FacebookLoginButton'
	import GoogleLoginButton from '@/components/GoogleLoginButton'

	export default {
		components: { ModalHeaderTitle, FacebookLoginButton, GoogleLoginButton },
		name: "Register",

		data() {
			return {
				nombre: "",
				email: "",
				password: "",
				equipo: '',
				image: '',
				errors: [],
				fbid: null
			};
		},
		watch: {
			googleUser: function(guser){
				let google = guser.getBasicProfile()
				
				this.nombre = google.getName()
				this.email = google.getEmail()
				this.image = google.getImageUrl() 
			},
			facebookUser: function(fuser){
				this.nombre = fuser.name
				this.email = fuser.email
				this.image = 'https://graph.facebook.com/v3.3/'+ fuser.id +'/picture?type=large'
				this.fbid = fuser.id
			}
		},
		methods: {
			register() {
				this.errors = [];
				this.$store
				.dispatch(
					"user/register",
					{
						nombre: this.nombre,
						email: this.email,
						password: this.password,
						equipo: this.equipo,
						image: this.image,
						fbid: this.fbid
					},
					this
					)
				.then(resp => {
					if (resp) {
						this.errors = resp.data;
					} else {
						this.$router.push(this.gotoRoute)
						.then(() => {
							this.$emit('tryCloseModal')
						})
						.catch(err => {
							//Cuando se hace el login en una pagina del sitio
							if (err != undefined && err.name == "NavigationDuplicated") {
								//Close login modal
								this.$emit('tryCloseModal',{unir_quiniela: true})
							}else{
								this.$emit('tryCloseModal')
							}
						})
					}
				});
			},
			fbSuccess(resp){
				//Traer info usuario
				window.FB.api('me?fields=email,name', user => { 
					this.$store.dispatch('user/loginFacebook',{
						token: resp.authResponse.accessToken,
						facebookUser: user
					})
					.then(response => {
						console.log(response)
						if (response) {
							if (response.usuarioNoRegistrado) {
								//notificar al usuario que termine el registro
								this.$store.dispatch('notification/add',{
									type: 'success',
									message: 'Completa tu información y haz click en "Registrar" para iniciar!!'
								})
							}
						}else{
							this.$router.push(this.gotoRoute)
							.then(() => {
								this.$emit('tryCloseModal')
							})
							.catch(err => {
								console.log('se cacho el error')
								//Cuando se hace el login en una pagina del sitio
								if (err.name == "NavigationDuplicated") {
									//Close login modal
									this.$emit('tryCloseModal',{unir_quiniela: true})
								}
							})
	                	}
					})
				})
			},
			fbFailed(){
				console.log('Fallo login con FB')
			},
			googleSuccess(googleUser){
				this.$store.dispatch('user/loginGoogle',{
					token: googleUser.getAuthResponse(true).access_token,
					googleUser: googleUser
				})
				.then(resp => {
					if (resp) {
						if (resp.usuarioNoRegistrado) {
							//notificar al usuario que termine el registro
							this.$store.dispatch('notification/add',{
								type: 'success',
								message: 'Completa tu información y haz click en "Registrar" para iniciar!!'
							})
						}
					}else{
						this.$router.push(this.gotoRoute)
						.then(() => {
							this.$emit('tryCloseModal')
						})
						.catch(err => {
							console.log('se cacho el error')
							//Cuando se hace el login en una pagina del sitio
							if (err.name == "NavigationDuplicated") {
								//Close login modal
								this.$emit('tryCloseModal',{unir_quiniela: true})
							}
						})
					}
                })
			},
			googleFailed(error){
				console.log(error.error);
			}
		},
		computed: {
			ligasNoVacias(){
				return this.ligas.filter(liga => {
					return liga.equipos.length > 0
				})
			},
			...mapState('ligas',['ligas']),
			...mapState('user',['googleUser']),
			...mapState('user',['facebookUser']),
			...mapState('login',['gotoRoute'])
		},
		created() {
			if (this.$store.state.ligas.ligas.length == 0) {
				this.$store.dispatch('ligas/fetchLigas',true)
			}
		}
	};
</script>

<style lang="css" scoped>
select option[disabled] { display: none; }
</style>
